import React from 'react'
import GaiaLogo, { TYPE_ROYAL_PLUS } from '../GaiaLogo/index'
import { H1, HEADING_TYPES } from '../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'

/**
 * The jumbotron component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onJoinButtonClick - The join gaia button event handler
 * @returns {JSX.Element} The jumbotron component
 */

function GaiaPlusJumbotron (props) {
  const {
    staticText,
    onJoinButtonClick,
  } = props

  return (
    <div className="gaia-plus-page__jumbotron">
      <div className="gaia-plus-page__jumbotron-container">
        <GaiaLogo type={TYPE_ROYAL_PLUS} />
        <H1 as={[HEADING_TYPES.H2_MOBILE, HEADING_TYPES.H1_DESKTOP]}>
          {staticText.get('jumbotronHeading')}
        </H1>
        <p className="gaia-plus-page__jumbotron-text">{staticText.get('jumbotronText')}</p>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          className="gaia-plus-page__jumbotron-button"
          onClick={onJoinButtonClick}
        >
          {staticText.get('joinGaiaPlusNow')}
        </Button>
      </div>
    </div>
  )
}

export default GaiaPlusJumbotron
